/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $user_id: String!
    $first_name: String
    $last_name: String
    $phone: String
    $email: String
    $active: Boolean
    $metadata: AWSJSON
    $customer_id: String
    $groups: [String]
  ) {
    updateUser(
      user_id: $user_id
      first_name: $first_name
      last_name: $last_name
      phone: $phone
      email: $email
      active: $active
      metadata: $metadata
      customer_id: $customer_id
      groups: $groups
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const publishToChatAssistant = /* GraphQL */ `
  mutation PublishToChatAssistant($result: ResultInput) {
    publishToChatAssistant(result: $result) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const publishToProperties = /* GraphQL */ `
  mutation PublishToProperties($result: ResultInput) {
    publishToProperties(result: $result) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const publishToFileUploader = /* GraphQL */ `
  mutation PublishToFileUploader($result: ResultInput) {
    publishToFileUploader(result: $result) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const publishToParcelSearch = /* GraphQL */ `
  mutation PublishToParcelSearch($result: ResultInput) {
    publishToParcelSearch(result: $result) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const publishToEmailReceive = /* GraphQL */ `
  mutation PublishToEmailReceive($result: ResultInput) {
    publishToEmailReceive(result: $result) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const publishToZillowProp = /* GraphQL */ `
  mutation PublishToZillowProp($result: ResultInput) {
    publishToZillowProp(result: $result) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const publishToSowAgent = /* GraphQL */ `
  mutation PublishToSowAgent($result: ResultInput) {
    publishToSowAgent(result: $result) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const publishToQmaAutomation = /* GraphQL */ `
  mutation PublishToQmaAutomation($result: ResultInput) {
    publishToQmaAutomation(result: $result) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const publishToCompsAgent = /* GraphQL */ `
  mutation PublishToCompsAgent($result: ResultInput) {
    publishToCompsAgent(result: $result) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const publishToExitStrategy = /* GraphQL */ `
  mutation PublishToExitStrategy($result: ResultInput) {
    publishToExitStrategy(result: $result) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const publishToExitStrategyChat = /* GraphQL */ `
  mutation PublishToExitStrategyChat($result: ResultInput) {
    publishToExitStrategyChat(result: $result) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const publishToPropertyRemoval = /* GraphQL */ `
  mutation PublishToPropertyRemoval($result: ResultInput) {
    publishToPropertyRemoval(result: $result) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const invokeBlastShare = /* GraphQL */ `
  mutation InvokeBlastShare(
    $property_id: String!
    $customer: String!
    $sender: String!
    $sender_role: String!
    $homeowner_email: String
    $hidden_address: Boolean!
    $calculation: AWSJSON!
    $paf_amount: Float!
    $payment_window_days: Int!
  ) {
    invokeBlastShare(
      property_id: $property_id
      customer: $customer
      sender: $sender
      sender_role: $sender_role
      homeowner_email: $homeowner_email
      hidden_address: $hidden_address
      calculation: $calculation
      paf_amount: $paf_amount
      payment_window_days: $payment_window_days
    ) {
      id
      statusCode
      status
      body
      __typename
    }
  }
`;
export const deallensSwipe = /* GraphQL */ `
  mutation DeallensSwipe(
    $deallens_id: String!
    $sender: String!
    $receiver: String!
    $swipe_status: String!
    $customer_id: String!
    $bogus_id: String
  ) {
    deallensSwipe(
      deallens_id: $deallens_id
      sender: $sender
      receiver: $receiver
      swipe_status: $swipe_status
      customer_id: $customer_id
      bogus_id: $bogus_id
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const shareDealLens = /* GraphQL */ `
  mutation ShareDealLens(
    $deallens_obj: AWSJSON!
    $property_address: String!
    $hidden_address: Boolean!
    $paf_amount: Float
    $payment_window_days: Int
  ) {
    shareDealLens(
      deallens_obj: $deallens_obj
      property_address: $property_address
      hidden_address: $hidden_address
      paf_amount: $paf_amount
      payment_window_days: $payment_window_days
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const makeOffer = /* GraphQL */ `
  mutation MakeOffer(
    $customer: String!
    $property_id: String!
    $collection_id: String!
    $offer_event: String!
    $offer_amount: Float
    $offer_terms: AWSJSON
    $metadata: AWSJSON
    $message: String
    $supersedes_offer_id: String
    $deallens_id: String
    $event_id: String
    $role: String
    $receiver: String
    $sender: String
    $paf_amount: Float
    $payment_window_days: Int
    $property_address: String
    $property_address_override: String
    $hidden_address: Boolean
  ) {
    makeOffer(
      customer: $customer
      property_id: $property_id
      collection_id: $collection_id
      offer_event: $offer_event
      offer_amount: $offer_amount
      offer_terms: $offer_terms
      metadata: $metadata
      message: $message
      supersedes_offer_id: $supersedes_offer_id
      deallens_id: $deallens_id
      event_id: $event_id
      role: $role
      receiver: $receiver
      sender: $sender
      paf_amount: $paf_amount
      payment_window_days: $payment_window_days
      property_address: $property_address
      property_address_override: $property_address_override
      hidden_address: $hidden_address
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const sendMessage = /* GraphQL */ `
  mutation SendMessage(
    $customer: String!
    $property_id: String!
    $collection_id: String!
    $message: String!
    $event_id: String
    $role: String
    $sender: String
    $deallens_id: String
    $property_address: String
    $property_address_override: String
    $hidden_address: Boolean
  ) {
    sendMessage(
      customer: $customer
      property_id: $property_id
      collection_id: $collection_id
      message: $message
      event_id: $event_id
      role: $role
      sender: $sender
      deallens_id: $deallens_id
      property_address: $property_address
      property_address_override: $property_address_override
      hidden_address: $hidden_address
    ) {
      statusCode
      body
      __typename
    }
  }
`;
export const createPropertyShortLink = /* GraphQL */ `
  mutation CreatePropertyShortLink($propertyId: String!, $customer: String!) {
    createPropertyShortLink(propertyId: $propertyId, customer: $customer) {
      statusCode
      body
      __typename
    }
  }
`;
export const linkDeallens = /* GraphQL */ `
  mutation LinkDeallens(
    $customer: String!
    $property_id: String!
    $sender_id: String!
    $receiver_id: String!
    $calculation: AWSJSON!
    $sender_role: String
    $receiver_role: String
    $county: String
    $bed: Float
    $bath: Float
    $sqft: Float
    $year_built: Float
    $full_address: String
    $city: String
    $state: String
    $zipcode: String
    $homeowner_email: String
    $representative: String
    $hidden_address: Boolean
    $metadata: AWSJSON
    $offer_id: String
  ) {
    linkDeallens(
      customer: $customer
      property_id: $property_id
      sender_id: $sender_id
      receiver_id: $receiver_id
      calculation: $calculation
      sender_role: $sender_role
      receiver_role: $receiver_role
      county: $county
      bed: $bed
      bath: $bath
      sqft: $sqft
      year_built: $year_built
      full_address: $full_address
      city: $city
      state: $state
      zipcode: $zipcode
      homeowner_email: $homeowner_email
      representative: $representative
      hidden_address: $hidden_address
      metadata: $metadata
      offer_id: $offer_id
    )
  }
`;
export const removeProperty = /* GraphQL */ `
  mutation RemoveProperty(
    $customer: String!
    $property_id: String!
    $user_email: String!
    $subscription_id: String!
  ) {
    removeProperty(
      customer: $customer
      property_id: $property_id
      user_email: $user_email
      subscription_id: $subscription_id
    ) {
      statusCode
      body
      __typename
    }
  }
`;
